import styled from 'styled-components';
import SwiLab02 from 'dc/SwiLab02';

export const RadioWrapper = styled.div`
  width: 100%;
  margin: 20px 0 28px;
  padding-left: 14px;
`;

export const Radio = styled(SwiLab02)`
  margin-bottom: 12px;
  div {
    color: #90a4ae;
  }
  span {
    color: #37474f;
  }
`;
